// extracted by mini-css-extract-plugin
export default {"add-programs-header":"AddProgramsHeader_add-programs-header__GC3HO","title":"AddProgramsHeader_title__QThjI","icon-subcontainer":"AddProgramsHeader_icon-subcontainer__GV7uR"};